import { Skeleton } from '@heroui/react';

export type OrderStatusProps = {
  variant?: 'idle' | 'delivery' | 'ready' | 'accepted' | 'cancelled';
  isLoading?: boolean;
  className?: string;
};

export const OrderStatus = ({
  isLoading = false,
  variant = 'idle',
  className = '',
}: OrderStatusProps) => {
  switch (variant) {
    case 'idle':
      return (
        <Skeleton isLoaded={!isLoading} className="rounded-md">
          <p className={`text-[#F5A524] text-sm font-semibold ${className}`}>
            В обработке
          </p>
        </Skeleton>
      );
    case 'delivery':
      return (
        <Skeleton isLoaded={!isLoading} className="rounded-md">
          <p className={`text-[#2D7BEF] text-sm font-semibold ${className}`}>
            На доставке
          </p>
        </Skeleton>
      );
    case 'ready':
      return (
        <Skeleton isLoaded={!isLoading} className="rounded-md">
          <p className={`text-[#2D7BEF] text-sm font-semibold ${className}`}>
            Сборка в процессе
          </p>
        </Skeleton>
      );
    case 'accepted':
      return (
        <Skeleton isLoaded={!isLoading} className="rounded-md">
          <p className={`text-[#17C964] text-sm font-semibold ${className}`}>
            Получен
          </p>
        </Skeleton>
      );
    case 'cancelled':
      return (
        <Skeleton isLoaded={!isLoading} className="rounded-md">
          <p className={`text-[#F53639] text-sm font-semibold ${className}`}>
            Отменен
          </p>
        </Skeleton>
      );
  }
};
